import {
  AppBar,
  makeStyles,
  Toolbar,
  Typography,
  CardContent,
  Card,
} from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { useIntl } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  panelHeader: {
    backgroundColor: theme.palette.primary.background,
  },
}))

export function PlanBillingCard({ labelId, children }) {
  const { formatMessage } = useIntl()
  const classes = useStyles()
  return (
    <Card elevation={1} className="flex-auto mb-48">
      {labelId && (
        <AppBar
          color="default"
          position="static"
          elevation={0}
          className={clsx(classes.panelHeader, 'border-b-1 border-solid ')}
        >
          <Toolbar className="ltr:pl-16 rtl:pr-16 ltr:pr-8 rtl:pl-8  title">
            <Typography variant="subtitle1" className="flex-1 font-bold">
              {formatMessage({
                id: labelId,
              })}
            </Typography>
          </Toolbar>
        </AppBar>
      )}
      <CardContent>{children}</CardContent>
    </Card>
  )
}
